var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('TabAndAd'),_c('NoticeArea',{attrs:{"announcements":_vm.announcements,"noticeType":_vm.noticeType},on:{"region-change":_vm.handleRegionChange,"property-change":_vm.handlePropertyChange,"noticeType":_vm.handleNoticeType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }